import { TypeaheadResultsItem } from 'foundations-components/transitional/components/Typeahead';
import { jsx as _jsx } from "react/jsx-runtime";
export const getOptionId = index => {
  return `autocomplete-option-${index}`;
};
export const SearchAutocompleteResultItem = ({
  option,
  index,
  highlightedOptionIndex,
  onMouseEnter,
  onClick,
  itemComponent
}) => {
  return /*#__PURE__*/_jsx(TypeaheadResultsItem, {
    highlighted: highlightedOptionIndex === index,
    id: getOptionId(index),
    itemComponent: itemComponent,
    onClick: () => {
      onClick(option, index);
    },
    onMouseEnter: () => {
      onMouseEnter(option, index);
    },
    option: option
  });
};